import ApiContext from 'api/ApiContext';
import { ListType } from 'api/api.types';
import { useContext, useMemo } from 'react';
import { FormattedList } from './getFormattedCandidates';

export const useGetFormattedParties = (
  unformattedParties: ListType[],
  formattedLists: FormattedList[],
  isFinal?: boolean,
  finishedCircles?: number,
): FormattedList[] => {
  const { language } = useContext(ApiContext);

  const parties = useMemo(() => {
    return unformattedParties?.map((li: ListType) => {
      const mainListOfParty = formattedLists.find((list) => {
        return list.partyId === li.id;
      });

      return {
        title: li.title[language],
        shortTitle: li.short_title[language],
        seatsClaimed: li.results?.seat_claim || 0,
        listId: li.id,
        color: li.color,
        listNumber: mainListOfParty?.listNumber, // only available for IssueList
        votesRelative: li.results.party_votes_percentage,
        votesAbsolute: li.results.party_votes,
        partyId: li.id,
      };
    });
  }, [!unformattedParties, isFinal, finishedCircles]);

  return parties;
};
